import React from "react";

// STYLES
import styled, { keyframes } from "styled-components";
import Colors from "../../shared/colors";

// ICONS
import MdArrowDropDown from "react-icons/lib/md/arrow-drop-down";

// ANIMATION
import { fadeIn } from "react-animations";

export default class Dropdown extends React.Component {
  state = { isOpen: false };

  render() {
    let { isOpen } = this.state;
    let { i18n } = this.props;

    const openDrop = () => {
      if (this.state.isOpen === false) {
        this.setState({ isOpen: true });
      } else {
        this.setState({ isOpen: false });
      }
    };

    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      this.setState({ isOpen: false });
      this.props.setLogo(i18n);
    };

    const Drop = styled.div`
      margin-left: 15px;
      color: ${this.props.onSrollHeader ? "#FFF" : "hsl(0, 0%, 17%)"};
      position: relative;
      z-index: 10;
    `;

    return (
      <Drop>
        <Button
          onClick={() => {
            openDrop();
          }}
        >
          <ButtonText>{i18n.language}</ButtonText>
          <ButtonIcon>
            <MdArrowDropDown />
          </ButtonIcon>
        </Button>
        {isOpen && (
          <DropList>
            {i18n.language !== "de" && (
              <DropItem onClick={() => changeLanguage("de")}>de</DropItem>
            )}
            {i18n.language !== "en" && (
              <DropItem onClick={() => changeLanguage("en")}>en</DropItem>
            )}
            {i18n.language !== "es" && (
              <DropItem onClick={() => changeLanguage("es")}>es</DropItem>
            )}
            {i18n.language !== "fr" && (
              <DropItem onClick={() => changeLanguage("fr")}>fr</DropItem>
            )}
            {i18n.language !== "pt" && (
              <DropItem onClick={() => changeLanguage("pt")}>pt</DropItem>
            )}
            {i18n.language !== "ja" && (
              <DropItem onClick={() => changeLanguage("ja")}>ja</DropItem>
            )}
          </DropList>
        )}
      </Drop>
    );
  }
}

const fadeInAnimation = keyframes`${fadeIn}`;

const Button = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const ButtonText = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
`;
const ButtonIcon = styled.div`
  font-size: 22px;
`;
const DropList = styled.div`
  position: absolute;
  top: 25px;
  background-color: ${Colors.white};
  border-radius: 5px;
  color: ${Colors.text.secondary};
  box-shadow: 0 2px 4px 0 rgba(34, 36, 38, 0.12),
    0 2px 10px 0 rgba(34, 36, 38, 0.15);
  animation: 0.5s ${fadeInAnimation};
  z-index: 11;
`;
const DropItem = styled.div`
  padding: 8px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;

  &:hover {
    color: ${Colors.primary};
  }
`;



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown.component.js